export interface FaqItem {
  id: number;
  category: string;
  question: string;
  answer: string;
}

export interface Testimonial {
  id: number;
  name: string;
  role: string;
  text: string;
  initial: string;
}

export interface StatItem {
  value: string;
  label: string;
  icon: string;
}

export interface Milestone {
  year: string;
  title: string;
  text: string;
}

export const faqs: FaqItem[] = [
  {
    id: 1,
    category: '内容与来源',
    question: '瓜田观察的内容是怎么来的？',
    answer:
      '每个话题页都会先做事件梳理，再汇总目前可公开查到的各方说法，并附上时间线。我们尽量区分「已确认信息」「当事方公开回应」和「网友观点」三类内容，避免把讨论当成结论。',
  },
  {
    id: 2,
    category: '内容与来源',
    question: '为什么有些话题一直显示「等待回应」？',
    answer:
      '当相关方尚未公开回应、或者回应内容不足以解释争议时，话题会保持「等待回应」状态。这个标签只描述当前的信息状态，不代表任何立场判断。',
  },
  {
    id: 3,
    category: '内容与来源',
    question: '讨论区的观点会经过筛选吗？',
    answer:
      '我们会过滤涉及人身攻击、泄露他人隐私、散布未经证实的个人信息的内容，保留基于事实、可讨论的观点。筛选标准是「是否针对事情」，而不是「是否符合某种立场」。',
  },
  {
    id: 4,
    category: '使用与互动',
    question: '我可以自己发布话题或线索吗？',
    answer:
      '可以。在「联系我们」页面提交线索时，请尽量附上可核实的公开来源与时间信息。收到线索后我们会先做基础核实，再决定是否整理成话题。',
  },
  {
    id: 5,
    category: '使用与互动',
    question: '为什么我发的讨论没有立刻显示？',
    answer:
      '当前讨论区为浏览器端本地演示，你发布的内容会立即出现在当前页面的讨论列表里，但不会同步到其他设备。等社区接入正式账号体系后，讨论将可以长期保存。',
  },
  {
    id: 6,
    category: '使用与互动',
    question: '可以按分类只看某一类话题吗？',
    answer:
      '可以。进入「话题广场」后，点击顶部的分类标签即可筛选，还可以配合关键词搜索和热度排序，快速找到感兴趣的方向。',
  },
  {
    id: 7,
    category: '版权与隐私',
    question: '如果话题涉及我本人，怎么处理？',
    answer:
      '请通过「联系我们」提交说明并附可核实的信息。对于确属失实或涉及个人隐私的内容，我们会在核实后调整或下架相关页面。',
  },
  {
    id: 8,
    category: '版权与隐私',
    question: '站内使用的图片和文字有版权吗？',
    answer:
      '站内配图均为主题示意图片，不使用当事人肖像。文字内容为编辑整理与网友讨论汇总，转载前请通过联系邮箱与我们沟通。',
  },
];

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: '林一舟',
    role: '内容编辑 · 关注网络舆论',
    text: '难得看到一个把时间线和各方说法放在第一位的讨论社区。看完一个话题页，基本能自己形成判断，而不是被情绪牵着走。',
    initial: '林',
  },
  {
    id: 2,
    name: '苏念',
    role: '普通读者 · 每晚必逛',
    text: '最舒服的是「等待回应」这种状态标签。信息不全就说不全，比那些一上来就盖章定论的地方靠谱太多。',
    initial: '苏',
  },
  {
    id: 3,
    name: '陈屿',
    role: '从业者 · 影视行业',
    text: '行业内的很多传闻，被这里整理成可核对的条目后，反而没那么容易被带节奏了。讨论区的氛围也比想象中理性。',
    initial: '陈',
  },
];

export const stats: StatItem[] = [
  { value: '1,860+', label: '已整理话题', icon: 'ri-article-line' },
  { value: '42.6万', label: '累计讨论条数', icon: 'ri-chat-3-line' },
  { value: '56', label: '覆盖内容领域', icon: 'ri-layout-grid-line' },
  { value: '每日 9:00', label: '热榜固定更新时间', icon: 'ri-time-line' },
];

export const milestones: Milestone[] = [
  {
    year: '2021',
    title: '从一个聊天群开始',
    text: '最开始只是一群朋友在群里互相核对消息真伪。后来发现「把时间线写下来」这件事本身就有价值，于是有了第一版话题整理模板。',
  },
  {
    year: '2023',
    title: '确定内容原则',
    text: '我们写下了三条原则：区分事实与观点、标注信息状态、不替当事人下结论。这三条至今仍是每一次编辑的起点。',
  },
  {
    year: '2025',
    title: '讨论区上线',
    text: '从单向整理转向共同讨论。网友的补充常常比编辑更快地找出时间线上的漏洞，这也是社区最迷人的部分。',
  },
  {
    year: '现在',
    title: '继续把瓜吃明白',
    text: '热度会过去，但对事情的理解会留下。我们希望每个话题页在热度散尽后，依然是一份可以阅读的记录。',
  },
];